export default __webpack_public_path__ + "static/media/PrivacyStatement-v2.f1fd9fe2.pdf";